import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const questionRouters = [
  {
    path: '/questions',
    name: 'Question',
    meta: {
      requiresAuth: false,
      title: '问题管理',
      code: 'QUESTION_LIST',
      displayPageHeader: true,
    },
    component: () => import('@/views/cms/question/QuestionList.vue'),
  },
  {
    path: '/questions/:questionId',
    name: 'QuestionEdit',
    meta: {
      requiresAuth: false,
      title: '问题编辑',
      code: 'QUESTION_EDIT',
      displayPageHeader: true,
    },
    component: () => import('@/views/cms/question/QuestionEdit.vue'),
  },
  {
    path: '/questions-add',
    name: 'QuestionAdd',
    meta: {
      requiresAuth: false,
      title: '添加问题',
      code: 'QUESTION_ADD',
      displayPageHeader: true,
    },
    props: true,
    component: () => import('@/views/cms/question/QuestionEdit.vue'),
  },
];

const mainRouters = [
  {
    path: '',
    name: 'Home',
    meta: {
      requiresAuth: true,
      title: '首页',
      code: 'HOME',
      displayPageHeader: false,
      keepAlive: true,
    },
    component: () => import('@/views/index/Home.vue'),
  },
  {
    path: '/account/settings',
    name: 'Setting',
    meta: {
      requiresAuth: true,
      title: '修改密码',
      code: 'CHANGE_PASSWORD',
      displayPageHeader: true,
    },
    component: () => import('@/views/account/Setting.vue'),
  },
];

const sysRouters = [
  {
    path: '/dictionary-management',
    name: 'DictionaryList',
    meta: {
      requiresAuth: true,
      title: '字典管理',
      displayPageHeader: true,
      keepAlive: true,
      refresh: false,
    },
    component: () => import('@/views/sys/dictionary/DictionaryList.vue'),
  },
  {
    path: '/organization',
    name: 'OrganizationList',
    meta: {
      requiresAuth: true,
      title: '组织管理',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/sys/organization/OrganizationList.vue'),
  },
  {
    path: '/sys-user',
    name: 'SysUserList',
    meta: {
      requiresAuth: true,
      title: '用户管理',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/sys/user/UserList.vue'),
  },
  {
    path: '/user-password',
    name: 'UserPassword',
    meta: {
      requiresAuth: true,
      title: '密码修改',
      displayPageHeader: true,
    },
    component: () => import('@/views/sys/user/UserPassword.vue'),
  },
  {
    path: '/menu',
    name: 'MenuList',
    meta: {
      requiresAuth: true,
      title: '菜单管理',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/sys/menu/MenuList.vue'),
  },
  {
    path: '/role',
    name: 'RoleList',
    meta: {
      requiresAuth: true,
      title: '角色管理',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/sys/role/RoleList.vue'),
  },
  {
    path: '/log',
    name: 'LogList',
    meta: {
      requiresAuth: true,
      title: '日志管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/sys/log/LogList.vue'),
  },
  {
    path: '/language',
    name: 'LanguageList',
    meta: {
      requiresAuth: true,
      title: '语言管理',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/sys/language/LanguageList.vue'),
  },
  {
    path: '/i18n-detail',
    name: 'I18NDetailList',
    meta: {
      requiresAuth: true,
      title: '翻译管理',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/sys/i18nDetail/I18NDetailList.vue'),
  },
  {
    path: '/constructing-page',
    name: 'ConstructingPage',
    meta: {
      requiresAuth: true,
      title: '页面建设中',
      displayPageHeader: true,
    },
    component: () => import('@/layout/ConstructingPage.vue'),
  },
  {
    path: '/coding-rule',
    name: 'CodingRuleList',
    meta: {
      requiresAuth: true,
      title: '编码规则',
      displayPageHeader: true,
    },
    component: () => import('@/views/sys/codingRule/CodingRuleList.vue'),
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/views/exception/404.vue'),
  },
];

const shopRouters = [

  {
    path: '/goods',
    name: 'GoodsList',
    meta: {
      requiresAuth: false,
      title: '商品列表',
      code: 'GOODS_LIST',
      displayPageHeader: true,
      isUseCache: false,
      keepAlive: true,
    },
    component: () => import('@/views/shop/goods/GoodsList.vue'),
  },
  {
    path: '/sell-plan',
    name: 'SellPlanList',
    meta: {
      requiresAuth: false,
      title: '预售计划',
      code: 'SELL_PLAN',
      displayPageHeader: true,
    },
    component: () => import('@/views/shop/sellPlan/SellPlanList.vue'),
  },
  {
    path: '/sell-plan/:sellPlanId/goods',
    name: 'SellPlanGoodsList',
    props: true,
    meta: {
      requiresAuth: false,
      title: '预售商品',
      code: 'SELL_PLAN_GOODS',
      displayPageHeader: true,
    },
    component: () => import('@/views/shop/sellPlan/SellPlanGoodsList.vue'),
  },
  {
    path: '/goods-add',
    name: 'GoodsAdd',
    meta: {
      requiresAuth: false,
      title: '添加商品',
      code: 'ADD_GOODS',
      displayPageHeader: true,
    },
    component: () => import('@/views/shop/goods/GoodsEdit.vue'),
  },
  {
    path: '/goods/:goodsId',
    name: 'GoodsEdit',
    props: true,
    meta: {
      requiresAuth: false,
      title: '商品编辑',
      code: 'EDIT_GOODS',
      displayPageHeader: false,
    },
    component: () => import('@/views/shop/goods/GoodsEdit.vue'),
  },
  {
    path: '/goods-inspiration/:goodsId',
    name: 'GoodsInspirationList',
    props: true,
    meta: {
      requiresAuth: false,
      title: '商品灵感',
      code: 'INSPIRATION_GOODS',
      displayPageHeader: false,
    },
    component: () => import('@/views/shop/goods/GoodsInspirationList.vue'),
  },
  {
    path: '/appInfoDetail/:appInfoId',
    name: 'AppInfoDetailList',
    props: true,
    meta: {
      requiresAuth: false,
      title: '尺寸详情',
      code: 'APPINFO_DETAIL',
      displayPageHeader: false,
    },
    component: () => import('@/views/cms/appInfo/AppInfoDetailList.vue'),
  },
  {
    path: '/goods/:goodsId/skus',
    name: 'GoodsSkus',
    props: true,
    meta: {
      requiresAuth: false,
      title: '商品SKU',
      code: 'GOODS_SKU',
      displayPageHeader: false,
    },
    component: () => import('@/views/shop/goodsSku/GoodsSkuList.vue'),
  },
  {
    path: '/goods-category',
    name: 'GoodCategoryList',
    meta: {
      requiresAuth: false,
      title: '商品分类',
      code: 'GOODS_CATEGORY',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/shop/goodsCategory/GoodsCategoryList.vue'),
  },
  {
    path: '/goods-category/:categoryId',
    name: 'GoodsCategoryIdDetail',
    meta: {
      requiresAuth: false,
      title: '分类下的商品',
      code: 'GOODS_CATEGORY_DETAIL',
      displayPageHeader: true,
    },
    component: () => import('@/views/shop/goodsCategory/GoodsCategoryIdDetail.vue'),
  },
  {
    path: '/goods-series',
    name: '商品系列',
    meta: {
      requiresAuth: false,
      title: '商品系列',
      code: 'GOODS_SERIES',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/shop/goodsSeries/GoodsSeriesList.vue'),
  },
  {
    path: '/goods-brand',
    name: 'GoodBrandList',
    meta: {
      requiresAuth: false,
      title: '商品品牌',
      code: 'GOODS_BRAND',
      displayPageHeader: true,
    },
    component: () => import('@/views/shop/goodsBrand/GoodsBrandList.vue'),
  },

  {
    path: '/goods-brand/:brandId',
    name: 'GoodBrandDetail',
    meta: {
      requiresAuth: false,
      title: '商品详情',
      code: 'GOODS_DETAIL',
      displayPageHeader: true,
    },
    props: true,
    component: () => import('@/views/shop/goodsBrand/GoodsBrandDetail.vue'),
  },
  {
    path: '/orders',
    name: 'OrderList',
    meta: {
      requiresAuth: false,
      title: '订单列表',
      code: 'ORDER_LIST',
      displayPageHeader: true,
      isUseCache: true,
      keepAlive: true,
    },
    component: () => import('@/views/shop/order/OrderList.vue'),
  },
  {
    path: '/order/:orderId/detail',
    name: 'OrderDetail',
    meta: {
      requiresAuth: false,
      title: '订单详情',
      code: 'ORDER_DETAIL',
      displayPageHeader: false,
    },
    props: true,
    component: () => import('@/views/shop/order/OrderDetail.vue'),
  },
  {
    path: '/user',
    name: 'UserList',
    meta: {
      requiresAuth: false,
      title: '会员列表',
      code: 'USER_LIST',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/shop/user/UserList.vue'),
  },
];

const cmsRouters = [
  {
    path: '/index-poster',
    name: 'IndexPoster',
    meta: {
      requiresAuth: false,
      title: '首页海报',
      code: 'INDEX_POSTER',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/cms/indexPoster/IndexPosterList.vue'),
  },
  {
    path: '/index-images',
    name: 'IndexImage',
    meta: {
      requiresAuth: false,
      title: '图片编辑',
      code: 'INDEX_Image',
      displayPageHeader: true,
    },
    component: () => import('@/views/cms/indexImage/IndexImagesList.vue'),
  },
  {
    path: '/articles',
    name: 'Article',
    meta: {
      requiresAuth: false,
      title: '文章',
      code: 'ARTICLE',
      displayPageHeader: true,
    },
    component: () => import('@/views/cms/article/ArticleList.vue'),
  },
  {
    path: '/articles/add',
    name: 'ArticleADD',
    meta: {
      requiresAuth: false,
      title: '添加文章',
      code: 'ARTICLE_ADD',
      displayPageHeader: false,
    },
    component: () => import('@/views/cms/article/ArticleEdit.vue'),
  },
  {
    path: '/articles/:articleId',
    name: 'ArticleEdit',
    props: true,
    meta: {
      requiresAuth: false,
      title: '文章编辑',
      code: 'ARTICLE_EDIT',
      displayPageHeader: false,
    },
    component: () => import('@/views/cms/article/ArticleEdit.vue'),
  },
  {
    path: '/app-info',
    name: 'AppInfo',
    meta: {
      requiresAuth: false,
      title: '小程序信息',
      code: 'APP_INFO',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/cms/appInfo/AppInfoList.vue'),
  },
  {
    path: '/transport-info',
    name: 'TransportInfo',
    meta: {
      requiresAuth: false,
      title: '运输信息',
      code: 'TRANSPORT_INFO',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/cms/transportInfo/TransportInfoList.vue'),
  },
  {
    path: '/look-book-topic',
    name: 'LookBookTopic',
    meta: {
      requiresAuth: false,
      title: 'Look Book 主题',
      code: 'LOOK_BOOK_TOPIC',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/cms/lookBookTopic/LookBookTopicList.vue'),
  },
  {
    path: '/look-book',
    name: 'LookBook',
    meta: {
      requiresAuth: false,
      title: 'Look Book',
      code: 'LOOK_BOOK',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/cms/lookBook/LookBookList.vue'),
  },
  {
    path: '/look-books/:lookBookId/goods',
    name: 'LookBookGoodsList',
    props: true,
    meta: {
      requiresAuth: false,
      title: 'Look Book 页面',
      code: 'LOOK_BOOK_GOODS',
      displayPageHeader: false,
    },
    component: () => import('@/views/cms/lookBook/LookBookGoodsList.vue'),
  },
  {
    path: '/brand-news',
    name: 'BrandNews',
    meta: {
      requiresAuth: false,
      title: '品牌新闻',
      code: 'BRAND_NEWS',
      displayPageHeader: true,
    },
    component: () => import('@/views/cms/brandNews/BrandNewsList.vue'),
  },
  {
    path: '/news',
    name: 'News',
    meta: {
      requiresAuth: false,
      title: '品牌故事',
      code: 'NEWS',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/cms/news/NewsList.vue'),
  },
  {
    path: '/news/:newsId',
    name: 'NewsDetailEdit',
    meta: {
      requiresAuth: false,
      title: '品牌故事详情',
      code: 'NEWS_EDIT',
      displayPageHeader: false,
    },
    props: true,
    component: () => import('@/views/cms/news/NewsEdit.vue'),
  },
  {
    path: '/news/:newsId/content',
    name: 'NewsDetail',
    meta: {
      requiresAuth: false,
      title: '品牌故事详情',
      code: 'NEWS_CONTENT',
      displayPageHeader: false,
    },
    props: true,
    component: () => import('@/views/cms/news/NewsContent.vue'),
  },
  {
    path: '/hot-search',
    name: 'HotSearch',
    meta: {
      requiresAuth: false,
      title: '热门搜索',
      code: 'HOT_SEARCH',
      displayPageHeader: true,
    },
    component: () => import('@/views/cms/hotSearch/HotSearchList.vue'),
  },
  {
    path: '/faq',
    name: 'FqaDict',
    meta: {
      requiresAuth: true,
      title: 'FAQ管理',
      code: 'FAQ',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/cms/fqa/FqaDictList.vue'),
  },
  {
    path: '/vip-invitation',
    name: 'INVITATION',
    meta: {
      requiresAuth: true,
      title: 'INVITATION审核',
      code: 'INVITATION',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/cms/invitation/Invitation.vue'),
  },
  {
    path: '/users/:userId',
    name: 'UserView',
    meta: {
      requiresAuth: false,
      title: '用户详情',
      code: 'USER_INFO',
      displayPageHeader: false,
    },
    props: true,
    component: () => import('@/views/shop/user/UserView.vue'),
  },
  {
    path: '/goods-attributes',
    name: 'GoodsAttributes',
    meta: {
      requiresAuth: false,
      title: '商品规格',
      code: 'GOODS_ATTRIBUTE',
      displayPageHeader: true,
    },
    props: true,
    component: () => import('@/views/shop/goodsAttribute/GoodsAttributeList.vue'),
  },
];

const websiteRouters = [
  {
    path: '/website-series',
    name: 'WebsiteSeries',
    meta: {
      requiresAuth: false,
      title: '网站系列',
      code: 'WEBSITE_SERIES',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/series/SeriesList.vue'),
  },
  {
    path: '/website-news',
    name: 'WebsiteNews',
    meta: {
      requiresAuth: false,
      title: '网站探索',
      code: 'WEBSITE_NEWS',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/news/WebsiteNewsList.vue'),
  },
  {
    path: '/website-news/:newsId',
    name: 'WebsiteNewsEdit',
    meta: {
      requiresAuth: false,
      title: '网站探索编辑',
      code: 'WEBSITE_NEWS_EDIT',
      displayPageHeader: false,
      keepAlive: true,
    },
    props: true,
    component: () => import('@/views/website/news/WebsiteNewsEdit.vue'),
  },
  {
    path: '/website-news/:newsId/content',
    name: 'WebsiteNewsDetail',
    meta: {
      requiresAuth: false,
      title: '探索详情',
      code: 'WEBSITE_NEWS_CONTENT',
      displayPageHeader: false,
    },
    props: true,
    component: () => import('@/views/website/news/WebsiteNewsContent.vue'),
  },
  {
    path: '/website-goods-tag',
    name: 'WebsiteGoodsTag',
    meta: {
      requiresAuth: false,
      title: '商品标签',
      code: 'WEBSITE_GOODS_TAG',
      displayPageHeader: true,
      keepAlive: true,
    },
    props: true,
    component: () => import('@/views/website/goods/GoodsTagList.vue'),
  },
  {
    path: '/website-goods',
    name: 'WebsiteGoods',
    meta: {
      requiresAuth: false,
      title: '网站商品',
      code: 'WEBSITE_GOODS',
      displayPageHeader: true,
      isUseCache: false,
      keepAlive: true,
    },
    props: true,
    component: () => import('@/views/website/goods/WebsiteGoodsList.vue'),
  },
  {
    path: '/website-goods-add',
    name: 'WebsiteGoodsAdd',
    meta: {
      requiresAuth: false,
      title: '添加网站商品',
      code: 'ADD_WEBSITE_GOODS',
      displayPageHeader: true,
    },
    component: () => import('@/views/website/goods/WebsiteGoodsEdit.vue'),
  },
  {
    path: '/taxes',
    name: 'TaxList',
    meta: {
      requiresAuth: false,
      title: '税率列表',
      code: 'WEBSITE_TAX_LIST',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/tax/TaxList.vue'),
  },
  {
    path: '/website-newsletter',
    name: 'NewsletterList',
    meta: {
      requiresAuth: false,
      title: '广告订阅列表',
      code: 'WEBSITE_NEWSLETTER',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/newsletter/WebsiteNewsletter.vue'),
  },
  {
    path: '/website-appointment',
    name: 'WebsiteAppointment',
    meta: {
      requiresAuth: false,
      title: '定制预约',
      code: 'WEBSITE_APPOINTMENT',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/appointment/WebsiteAppointment.vue'),
  },
  {
    path: '/website-goods-inquire',
    name: 'WebsiteGoodsInquire',
    meta: {
      requiresAuth: false,
      title: '商品咨询',
      code: 'WEBSITE_GOODS_INQUIRE',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/inquire/WebsiteGoodsInquire.vue'),
  },
  {
    path: '/website-goods/:goodsId',
    name: 'WebsiteGoodsEdit',
    props: true,
    meta: {
      requiresAuth: false,
      title: '网站商品编辑',
      code: 'EDIT_WEBSITE_GOODS',
      displayPageHeader: false,
    },
    component: () => import('@/views/website/goods/WebsiteGoodsEdit.vue'),
  },
  {
    path: '/website-goods/:goodsId/skus',
    name: 'WebsiteGoodsSkus',
    props: true,
    meta: {
      requiresAuth: false,
      title: '网站商品SKU',
      code: 'WEBSITE_GOODS_SKU',
      displayPageHeader: false,
    },
    component: () => import('@/views/website/goods/WebsiteGoodsSkuList.vue'),
  },
  {
    path: '/website-category',
    name: 'WebsiteCategory',
    meta: {
      requiresAuth: false,
      title: '网站分类',
      code: 'WEBSITE_CATEGORY',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/category/WebsiteGoodsCategoryList.vue'),
  },
  {
    path: '/website-category/:categoryId',
    name: 'WebsiteGoodsCategoryDetail',
    meta: {
      requiresAuth: false,
      title: '分类下的商品',
      code: 'WEBSITE_GOODS_CATEGORY_DETAIL',
      displayPageHeader: true,
    },
    component: () => import('@/views/website/category/WebsiteGoodsCategoryDetail.vue'),
  },
  {
    path: '/website-instagram',
    name: 'WebsiteInstagram',
    meta: {
      requiresAuth: false,
      title: 'Instagram',
      code: 'WEBSITE_INSTAGRAM',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/instagram/InstagramList.vue'),
  },
  {
    path: '/instagram/:instagramId/positions',
    name: 'Instagram坐标',
    meta: {
      requiresAuth: false,
      title: 'Instagram坐标',
      code: 'INSTAGRAM_POSITION',
      displayPageHeader: true,
    },
    props: true,
    component: () => import('@/views/website/instagram/InstagramPositions.vue'),
  },
  {
    path: '/goods-price/:goodsId',
    name: 'GoodsPriceList',
    props: true,
    meta: {
      requiresAuth: false,
      title: '商品价格',
      code: 'PRICE_GOODS',
      displayPageHeader: false,
    },
    component: () => import('@/views/website/goods/GoodsPriceList.vue'),
  },
  {
    path: '/website-user',
    name: 'WebsiteUser',
    meta: {
      requiresAuth: false,
      title: '网站用户',
      code: 'WEBSITE_USER',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/user/WebsiteUserList.vue'),
  },
  {
    path: '/website-user/:userId',
    name: 'WebsiteUserView',
    meta: {
      requiresAuth: false,
      title: '网站用户详情',
      code: 'WEBSITE_USER_INFO',
      displayPageHeader: false,
    },
    props: true,
    component: () => import('@/views/website/user/WebsiteUserView.vue'),
  },
  {
    path: '/website-orders',
    name: 'WebsiteOrder',
    meta: {
      requiresAuth: false,
      title: '网站订单',
      code: 'WEBSITE_ORDER',
      displayPageHeader: true,
      isUseCache: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/order/WebsiteOrderList.vue'),
  },
  {
    path: '/website-order/:orderId/detail',
    name: 'WebsiteOrderDetail',
    meta: {
      requiresAuth: false,
      title: '网站订单详情',
      code: 'WEBSITE_ORDER_DETAIL',
      displayPageHeader: false,
    },
    props: true,
    component: () => import('@/views/website/order/WebsiteOrderDetail.vue'),
  },
  {
    path: '/goods-series-inspiration/:seriesId',
    name: 'GoodsSeriesInspirationList',
    props: true,
    meta: {
      requiresAuth: false,
      title: '系列灵感',
      code: 'INSPIRATION_SERIES',
      displayPageHeader: false,
    },
    component: () => import('@/views/website/series/GoodsSeriesInspirationList.vue'),
  },
  {
    path: '/goods-series-gather/:seriesId',
    name: 'GoodsSeriesGatherList',
    props: true,
    meta: {
      requiresAuth: false,
      title: '系列模特展示',
      code: 'GATHER_SERIES',
      displayPageHeader: false,
    },
    component: () => import('@/views/website/series/GoodsSeriesGatherList.vue'),
  },
  {
    path: '/goods-series-gather/:seriesId/positions',
    name: '模特展示商品',
    meta: {
      requiresAuth: false,
      title: '模特展示商品',
      code: 'GOODS_SERIES_GATHER_POSITION',
      displayPageHeader: true,
    },
    props: true,
    component: () => import('@/views/website/series/GoodsSeriesGatherPositions.vue'),
  },
  {
    path: '/website-story',
    name: 'WebsiteStory',
    props: true,
    meta: {
      requiresAuth: false,
      title: '定制故事',
      code: 'WEBSITE_STORY',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/story/WebsiteStoryList.vue'),
  },
  {
    path: '/website-order-add',
    name: 'WebsiteOrderAdd',
    meta: {
      requiresAuth: false,
      title: '添加订单',
      code: 'ADD_WEBSITE_ORDER',
      displayPageHeader: true,
    },
    component: () => import('@/views/website/order/WebsiteOrderCreate.vue'),
  },
  {
    path: '/website-gather',
    name: 'WebsiteGather',
    meta: {
      requiresAuth: false,
      title: '网站集合',
      code: 'WEBSITE_GATHER',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/gather/WebsiteGoodsGatherList.vue'),
  },
  {
    path: '/website-app-info',
    name: 'WebsiteAppInfo',
    meta: {
      requiresAuth: false,
      title: '网站字典项信息',
      code: 'WEBSITE_APP_INFO',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/appinfo/WebsiteAppInfoList.vue'),
  },
  {
    path: '/story/:storyId/positions',
    name: 'StoryDetail',
    meta: {
      requiresAuth: false,
      title: '定制故事详情',
      code: 'STORY_POSITION',
      displayPageHeader: true,
      keepAlive: true,
    },
    props: true,
    component: () => import('@/views/website/story/StoryPositions.vue'),
  },
  {
    path: 'website-ringsizers',
    name: 'websiteRingSizers',
    meta: {
      requiresAuth: false,
      title: '戒指尺寸测定器列表',
      code: 'WEBSITE_RING_SIZER',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/ringsizer/WebsiteRingSizerList.vue'),
  },
  {
    path: '/website-transport-info',
    name: 'WebsiteTransportInfo',
    meta: {
      requiresAuth: false,
      title: '网站物流',
      code: 'WEBSITE_TRANSPORT_INFO',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/transportInfo/WebsiteTransportInfoList.vue'),
  },
  {
    path: '/website-coupon',
    name: 'WebsiteCoupon',
    meta: {
      requiresAuth: false,
      title: '网站优惠券',
      code: 'WEBSITE_COUPON',
      displayPageHeader: true,
      keepAlive: true,
    },
    component: () => import('@/views/website/coupon/WebsiteCouponList.vue'),
  },
];

export default new Router({
  routes: [
    {
      path: '',
      meta: {
        requiresAuth: true,
        title: '',
      },
      component: () => import('@/layout/MainFramework.vue'),
      children: [
        ...mainRouters,
        ...sysRouters,
        ...shopRouters,
        ...cmsRouters,
        // ...lotteryRouters,
        ...questionRouters,
        ...websiteRouters,
      ],
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        requiresAuth: false,
        title: '',
      },
      component: () => import('@/views/login/Login.vue'),
    },
    {
      path: '/test',
      name: 'Test',
      meta: {
        requiresAuth: false,
        title: '',
      },
      component: () => import('@/views/test/Test.vue'),
    },
    // {
    //   path: '*',
    //   redirect: {
    //     name: '404',
    //   },
    // },
  ],
});
